module.exports = __webpack_public_path__ + "static/media/opening1.bba00caf.jpeg";